import { Divider, Stack } from "@mui/material"
import type { FormTab, YupTypes } from "@pharmupp/p3-front-commons"
import { Assignment } from "./Assignment/Assignment"
import { assignmentSchema } from "./Assignment/Assignment.schema"
import { Billing, billingSchema } from "./Billing"

export const administrativeSchema = assignmentSchema.concat(billingSchema)

export type AdministrativeFormValues = YupTypes.InferType<
  typeof administrativeSchema
>

const AdministrativeTabContent = () => {
  return (
    <Stack divider={<Divider flexItem />}>
      <Assignment />
      <Billing />
    </Stack>
  )
}

export const administrativeTabs: FormTab[] = [
  {
    label: "Identifiants",
    to: ".",
    Element: AdministrativeTabContent,
    schema: administrativeSchema,
  },
]
